/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WorkdayArray } from '../models/WorkdayArray'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class WorkdaysService {
  /**
   * 📱 Get workdays with events of the employee that is associated with the authenticated user
   * @param startDate Only get workdays with date after or equal the value of this parameter
   * @param endDate Only get workdays with date before or equal the value of this parameter
   * @param employeeId Get workdays for speciefic employee
   * @returns any OK
   * @throws ApiError
   */
  public static getWorkdays(
    startDate?: string,
    endDate?: string,
    employeeId?: number,
  ): CancelablePromise<{
    data?: WorkdayArray
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workdays',
      query: {
        start_date: startDate,
        end_date: endDate,
        employee_id: employeeId,
      },
      errors: {
        401: `The request was unauthenticated`,
      },
    })
  }
}
